<div class="nh-bell">
  <button
    mat-icon-button
    type="button"
    class="nh-bell__trigger"
    [ewentsTooltip]="'header.notifications.title' | translate"
    ewentsTooltipPosition="below"
    [attr.aria-label]="'header.notifications.title' | translate"
    [attr.aria-expanded]="open()"
    (click)="toggle()"
  >
    <mat-icon>notifications</mat-icon>
    @if (unreadCount() > 0) {
      <span class="nh-bell__badge" aria-live="polite">{{ badgeLabel() }}</span>
    }
  </button>

  @if (open()) {
    <div
      class="nh-bell__panel"
      role="dialog"
      [attr.aria-label]="'header.notifications.panelTitle' | translate"
    >
      <header class="nh-bell__header">
        <div>
          <h2>{{ 'header.notifications.panelTitle' | translate }}</h2>
          @if (unreadCount() > 0) {
            <p>{{ 'header.notifications.unreadCount' | translate: { n: unreadCount() } }}</p>
          } @else {
            <p>{{ 'header.notifications.allCaughtUp' | translate }}</p>
          }
        </div>
        @if (unreadCount() > 0) {
          <button type="button" class="nh-bell__mark-all" (click)="markAllRead()">
            {{ 'header.notifications.markAllRead' | translate }}
          </button>
        }
      </header>

      <div class="nh-bell__list">
        @if (loading()) {
          <p class="nh-bell__empty">{{ 'header.notifications.loading' | translate }}</p>
        } @else if (items().length === 0) {
          <div class="nh-bell__empty-state">
            <mat-icon>notifications_none</mat-icon>
            <p>{{ 'header.notifications.emptyTitle' | translate }}</p>
            <span>{{ 'header.notifications.emptyHint' | translate }}</span>
          </div>
        } @else {
          @for (item of items(); track item.id) {
            <div
              class="nh-bell__item"
              [class.nh-bell__item--unread]="!item.readAt"
              role="button"
              tabindex="0"
              (click)="onItemClick(item)"
              (keydown.enter)="onItemClick(item)"
              (keydown.space)="$event.preventDefault(); onItemClick(item)"
            >
              <span class="nh-bell__dot" aria-hidden="true"></span>
              <span class="nh-bell__item-body">
                <span
                  class="nh-bell__title"
                  [ewentsTooltip]="item.title"
                  ewentsTooltipOnlyWhenTruncated
                  ewentsTooltipPosition="below"
                  >{{ item.title }}</span
                >
                <span
                  class="nh-bell__text"
                  [ewentsTooltip]="item.body"
                  ewentsTooltipOnlyWhenTruncated
                  ewentsTooltipPosition="below"
                  >{{ item.body }}</span
                >
                <span class="nh-bell__meta">{{ relativeTime(item.createdAt) }}</span>
              </span>
              <button
                type="button"
                class="nh-bell__delete"
                [attr.aria-label]="'header.notifications.delete' | translate"
                [ewentsTooltip]="'header.notifications.delete' | translate"
                (click)="onDelete($event, item)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
